import React, { useState } from 'react';
import { TextControl, TextAreaControl } from '../InputControls';
import { Link } from 'react-router-dom';
import { makeRequest, validateEmail } from '../../utils';

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  document.title = `Contact Us | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Contact information and F.A.Q.s for Hanuman Editions.`);


  const submit = async () => {
    if (!validateEmail(email)) {
      setStatusMessage('Please enter a valid email address.');
      return;
    } else if (!message) {
      setStatusMessage('Please enter a message.');
      return;
    } else if (!name) {
      setStatusMessage('Please enter your name.');
      return;
    }
    let body = {
      email: email,
      message: message,
      name: name,
    };
    let send = await makeRequest('contact', 'POST', body);
    setStatusMessage('Thanks! We will be in touch shortly.');
    setSubmitted(true);
  }

  return (
    <div className='pageContainer'>
      <ul className='menu'>
        <li><Link to='/about'>About</Link></li>
        <li><Link to='/series/one'>Series One</Link></li>
        <li><Link to='/from-the-editors'>From the Editors</Link></li>
        <li><span className='chosen'>Contact</span></li>
      </ul>
      <div className='mainText'>
        <h2>F.A.Q.s</h2>

        <p className='bold'>Q: When can I order books? Are they available yet?</p>

        <p>A: We will announce the first six Hanuman Editions titles in late summer 2023, after which they will be available for pre-order. You can sign up for our mailing list and/or follow us on social media @hanumaneds to get the latest news on upcoming title announcements and on-sale dates.</p>

        <p className='bold'>Q: Can I be added to your press list?</p>

        <p>A: Sure! Just send us a message below indicating what types of titles you typically review along with the outlets you work for or most commonly publish with.</p>

        <p className='bold'>Q: Will you be selling books from the original Hanuman Books series as well?</p>

        <p>A: We will not be selling books from Hanuman Books. They are out-of-print and extremely collectible. We will, however, be reissuing select works from the Hanuman Books catalog over time, beginning this autumn.</p>

        <p className='bold'>Q: Will you offer subscriptions?</p>

        <p>A: Yes! We will offer subscriptions beginning with the announcement of our first six titles in late summer 2023.</p>

        <p className='bold'>Q: How do I buy your book for my store, library, class, etc?</p>

        <p>A: Our books are available at a discount to bookstores, libraries, and educators via our distributor, Asterism Books.</p>

        <p className='bold'>Q: Do you accept submissions?</p>

        <p>A: We are not accepting submissions at this time.</p>

        <hr />

        <p>For general inquiries, including press and publicity, contact us using the form below, or email us at editors@hanumaneditions.com</p>

        <p>For information on wholesale rates for bookstores, libraries, book clubs, or other retail outlets, our books will be available at <a href='https://asterismbooks.com/for-retailers'>asterismbooks.com</a></p>

        <hr />

        {!submitted && <div>
          <TextControl
            label='Your Name'
            value={name}
            change={setName}
          />
          <TextControl
            label='Your Email'
            value={email}
            change={setEmail}
          />
          <TextAreaControl
            label='Message'
            value={message}
            rows={4}
            change={setMessage}
          />


          <button onClick={submit}>Submit</button>
        </div>}

        {statusMessage && <div className={`emailMessage ${submitted && 'emailSuccess'}`}>{statusMessage}</div>}
      </div>
    </div>
  )
}